import { cn } from "../../lib/utils";
import { leaveStatusBadgeClass, leaveStatusLabel } from "./utils";
import type { LeaveApprovalStatus } from "@/services/APIs/PtsLeaveApprovalService";

export function LeaveApprovalStatusBadge({
  status,
}: {
  status?: LeaveApprovalStatus | null;
}) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium",
        leaveStatusBadgeClass(status)
      )}
    >
      {leaveStatusLabel(status)}
    </span>
  );
}
